const $global = global;
export default $global;
